export enum MODALS {
  CONTACT_SALES = 'CONTACT_SALES',
}
